import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Typography,
} from "@mui/material";

import { TReadBudgetsResponse } from "../../../../../../../../services/budget/read-budgets";
import {
    TBudgetLevelDetailed,
    TReadBudgetsLevelsDetailsByIdResponse,
} from "../../../../../../../../services/budget/read-budgets-levels-detailed-by-id";

interface IScopeTableProps {
    budgetData: TReadBudgetsResponse;
    items?: TReadBudgetsLevelsDetailsByIdResponse;
}

const CollapsibleRow = ({ row }: { row: TBudgetLevelDetailed }) => {
    const { Level, Parent } = row;

    const grandpaFeature = Parent?.Parent ?? null;
    const fatherFeature = Parent;

    return (
        <>
            <TableRow
                sx={{
                    boxShadow: "unset",
                }}
            >
                {grandpaFeature && (
                    <TableCell align="left">
                        <Typography
                            variant="body2"
                            sx={{
                                fontFamily: "Noto Sans",
                                color: grandpaFeature.color ?? "inherit",
                            }}
                        >
                            {grandpaFeature.name}
                        </Typography>
                    </TableCell>
                )}
                {fatherFeature && (
                    <TableCell align="left">
                        <Typography
                            variant="body2"
                            sx={{
                                fontFamily: "Noto Sans",
                                color: fatherFeature.color ?? "inherit",
                            }}
                        >
                            {fatherFeature.name}
                        </Typography>
                    </TableCell>
                )}
                <TableCell align="left">
                    <Typography
                        variant="body2"
                        sx={{
                            fontFamily: "Noto Sans",
                        }}
                    >
                        {Level.name}
                    </Typography>
                </TableCell>
            </TableRow>
        </>
    );
};

export default function ScopeTable({ budgetData, items }: IScopeTableProps) {
    const levelConfig = budgetData?.LevelConfig;
    return (
        <TableContainer component={Paper} variant="outlined">
            <Table>
                <TableHead>
                    <TableRow>
                        {levelConfig.map((levelData) => (
                            <TableCell>{levelData.name}</TableCell>
                        ))}
                    </TableRow>
                </TableHead>
                <TableBody>
                    {items?.map((item) => (
                        <CollapsibleRow key={item.Level.id_e} row={item} />
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
}
